export const body = {
    paddingRight: "30px",
    paddingTop: "20px"
};

export const columnRight = {
    textAlign: "right"
};

export const buttons = {
    textAlign: "center"
};

export const redText = {
    color: "red"
};

export const awaitDispatch = {
    fontWeight: "bold",
    color: "red",
    textAlign: "center"
};

export const printingProcess_title = {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "34px"
};

export const printingProcess_dispatch = {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "24px",
    color: "red"
};
